/* Outdoors Nordic - "Kops ofta ihop", motorn.
   =============================================
   Lag tidigare inline i blocks/on-fbt.liquid. Flyttad hit sa BADE blocket och
   variantvaljarens tillaggslista kan driva samma kort - en motor, inte tva.
   Skriptet definierar custom-elementet <on-fbt>, alltsa uppgraderas varje
   sadant element pa sidan oavsett vem som renderat det.

   ENDA andringen mot inline-versionen: adressen till varukorgen lastes med
   Liquid ({{ routes.cart_add_url }}). Den lases nu fran data-cart-add pa
   elementet, med /cart/add som fallback. */
  (function () {
    if (customElements.get('on-fbt')) return;
    function listOf(a) { return (a || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
    function setOf(a) { return new Set(listOf(a)); }
    class OnFbt extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-fbt-track]');
        this.prev = this.querySelector('[data-fbt-prev]');
        this.next = this.querySelector('[data-fbt-next]');
        if (this.prev) this.prev.addEventListener('click', () => this.scrollBy(-1));
        if (this.next) this.next.addEventListener('click', () => this.scrollBy(1));
        if (this.track) this.track.addEventListener('scroll', () => this.updateArrows());
        this.addEventListener('click', this.onClick.bind(this));
        /* Ett klick pa bilden eller namnet tog kunden bort fran produktsidan hen
           redan star pa, och da ar kopet borta. Nu oppnas SNABBVYN i stallet:
           samma produkt, samma sida. Snabbvyn (on-upsell-quickview) ligger i
           sidhuvudet pa alla sidor, sa kortet behover bara klicka sin egen
           [data-qv-open]. Saknas den stoppas lanken som forut i rent lage.
           Lyssnaren ligger pa roten och fangar aven kort som laggs till senare
           av det dynamiska laget.

           Plusset hoppas over: det ar SJALV en qv-trigger, sa den globala
           delegeringen tar det. Utan undantaget skulle vart eget klick studsa
           tillbaka hit och vi vore i en slinga. */
        /* Designen "Rader" (omgång 35): plusset, namnet och bilden fäller ut raden
           i stället för att lämna sidan eller öppna snabbvyn. */
        this.addEventListener('click', (e) => {
          if (!this.classList.contains('on-fbt--rows')) return;
          /* Köpboxens tillägg (omgång 43): bild och namn öppnar produkten i snabbvyn
             (bilder, beskrivning, storleksguide, val, köpknapp). Valen i raden finns
             kvar bakom plusset. "Ett par till" (data-rows-pair) fäller ut som förut. */
          const vpRow = this.classList.contains('on-fbt--vp') && !e.target.closest('[data-rows-pair]');
          const hit = e.target.closest(vpRow ? '[data-rows-toggle]' : '[data-rows-toggle], .on-fbt__title, .on-fbt__media');
          if (!hit || !this.contains(hit)) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          const card = hit.closest('[data-fbt-card]');
          if (!card) return;
          const open = !card.classList.contains('is-open');
          card.classList.toggle('is-open', open);
          const tg = card.querySelector('[data-rows-toggle]');
          if (tg) tg.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open && window.onFitSizes) setTimeout(window.onFitSizes, 0);
        }, true);
        this.addEventListener('click', (e) => {
          const clean = this.classList.contains('on-fbt--clean');
          const vp = this.classList.contains('on-fbt--vp');
          if (!clean && !vp) return;
          if (e.target.closest('.on-fbt__plus')) return;
          const a = e.target.closest('a');
          if (!a || !this.contains(a)) return;
          e.preventDefault();
          const card = a.closest('[data-fbt-card]');
          const qv = card && card.querySelector('[data-qv-open]');
          if (qv) qv.click();
        });
        this.addEventListener('change', this.onChange.bind(this));
        if (this.getAttribute('data-dynamic') === '1') {
          this.loadDynamic();
        } else {
          this.querySelectorAll('[data-fbt-card]').forEach((c) => this.initCard(c));
          this.enhanceRows();
          this.updateArrows();
        }
      }

      /* Märken 🏷️ (omgång 46): de automatiska förslagen ritas av en sektion som inte ser
         Tillägg ➕:s underblock, så märkena följer med som mallar (data-abadge = handtag)
         och sätts in här, på samma ställe som Liquid sätter dem på de valda produkterna. */
      applyBadges() {
        var self = this;
        this.querySelectorAll('template[data-abadge]').forEach(function (t) {
          var h = t.getAttribute('data-abadge');
          var pos = t.getAttribute('data-abpos') || 'above';
          self.querySelectorAll('[data-fbt-card]').forEach(function (card) {
            if (card.getAttribute('data-handle') !== h || card.hasAttribute('data-ab')) return;
            var b = t.content.firstElementChild;
            if (!b) return;
            b = b.cloneNode(true);
            card.setAttribute('data-ab', '');
            card.classList.add('on-fbt__card--ab-' + pos);
            var title = card.querySelector('.on-fbt__title');
            var media = card.querySelector('.on-fbt__mediawrap');
            if (pos === 'inline' && title) { title.appendChild(document.createTextNode(' ')); title.appendChild(b); }
            else if (pos === 'image' && media) media.insertBefore(b, media.firstChild);
            else if ((pos === 'ctl' || pos === 'ctr')) card.insertBefore(b, card.firstChild);
            else if (title) title.insertBefore(b, title.firstChild);
          });
        });
      }
      /* Rader: varje kort får underrad (Välj färg och storlek / Välj färg / Välj
         storlek), "fr." före priset när varianterna kostar olika, ett plus som
         fäller ut valen och knapptexten "Lägg till · pris". Raden "Ett par till"
         (data-rows-pair) får sin egen rubrik, underrad och beskrivning. Texterna
         kommer översatta från Liquid som data-attribut på elementet. */
      enhanceRows() {
        if (!this.classList.contains('on-fbt--rows')) return;
        var d = this;
        this.querySelectorAll('[data-fbt-card]:not([data-rows-done])').forEach(function (card) {
          card.setAttribute('data-rows-done', '');
          var title = card.querySelector('.on-fbt__title');
          var pair = card.closest('[data-rows-pair]');
          var sub = '';
          if (pair) {
            if (title) title.textContent = pair.getAttribute('data-rows-pair');
            sub = pair.getAttribute('data-rows-pair-sub') || '';
            var desc = pair.getAttribute('data-rows-pair-desc');
            var ctr = card.querySelector('.on-fbt__controls');
            if (desc && ctr) { var pd = document.createElement('p'); pd.className = 'on-fbt__rdesc'; pd.textContent = desc; ctr.insertBefore(pd, ctr.firstChild); }
          } else {
            var hc = card.getAttribute('data-has-color') === 'true' && !card.querySelector('.on-fbt__fixedcolor');
            var hs = card.getAttribute('data-has-size') === 'true';
            sub = hc && hs ? d.getAttribute('data-rows-cs') : (hc ? d.getAttribute('data-rows-c') : (hs ? d.getAttribute('data-rows-s') : ''));
          }
          if (title && sub) {
            var s = document.createElement('span');
            s.className = 'on-fbt__rsub';
            s.textContent = sub;
            title.insertAdjacentElement('afterend', s);
          }
          var ps = (card._variants || []).filter(function (v) { return v.available; }).map(function (v) { return v.price; });
          var pe = card.querySelector('[data-fbt-price]');
          if (pe && ps.length && Math.min.apply(null, ps) !== Math.max.apply(null, ps)) pe.setAttribute('data-rows-from', d.getAttribute('data-rows-from') || '');
          var tg = document.createElement('button');
          tg.type = 'button';
          tg.className = 'on-fbt__rtog';
          tg.setAttribute('data-rows-toggle', '');
          tg.setAttribute('aria-expanded', 'false');
          tg.setAttribute('aria-label', (title && title.textContent.trim()) || '');
          tg.innerHTML = '<span class="on-fbt__ric" aria-hidden="true"></span>';
          card.appendChild(tg);
          if (d.classList.contains('on-fbt--vp') && !pair) d.vpSkin(card);
          d.syncCard(card);
        });
      }

      /* SAMMA VÄLJARE SOM HUVUDVÄLJAREN (omgång 43). Tilläggets färger och storlekar
         ritas med kopior av Köpboxens egna knappar (färgruta, storleksknapp, rubrikrad,
         markering), så form, storlek och inställningar följer huvudväljaren. Kopiorna
         får data-fbt-* i stället för huvudväljarens data-fieldset-index/data-value och
         klassen on-variant-option, så huvudmotorn inte tar deras tryck. Storleken är
         ovald tills kunden väljer, som i huvudväljaren. Saknas en mall (huvudväljaren
         har ingen färg- eller storleksgrupp) står tilläggets egna val kvar. */
      vpSkin(card) {
        var host = this.closest('on-variant-picker');
        var main = host && host.querySelector('.on-vp:not(.on-vp--pair):not(.on-vp--addon)');
        var ctr = card.querySelector('.on-fbt__controls');
        if (!main || !ctr || card.querySelector('.on-vp--addon')) return;
        var strip = function (b) {
          b.classList.remove('on-variant-option', 'is-active', 'is-unavailable', 'on-vp__swatch--image');
          ['data-fieldset-index', 'data-value', 'data-available', 'data-alt', 'aria-current', 'aria-pressed'].forEach(function (a) { b.removeAttribute(a); });
          b.querySelectorAll('.on-vp__new, .on-size-alt, .on-vp__swatch-img, .on-vp__hexsrc, .on-vp__swatch-txt, [class*="bestseller"], [class*="on-bs"]').forEach(function (n) { n.remove(); });
          return b;
        };
        var label = function (type, nameTxt) {
          var ml = main.querySelector('.on-vp__group--' + type + ' .on-vp__name');
          var l = document.createElement('div');
          l.className = 'on-vp__label';
          var n = document.createElement('span');
          n.className = 'on-vp__name';
          n.textContent = (ml && ml.textContent.trim()) || nameTxt || '';
          l.appendChild(n);
          return l;
        };
        var wrap = document.createElement('div');
        wrap.className = 'on-vp on-vp--addon';
        var built = false;
        /* Färg */
        var oldSw = card.querySelector('.on-fbt__swatches');
        var swTpl = main.querySelector('.on-vp__swatch--color') || main.querySelector('.on-vp__swatch');
        var dotTpl = main.querySelector('.on-vp__swatch--color .on-swatch');
        if (oldSw && swTpl) {
          var g = document.createElement('div');
          g.className = 'on-vp__group on-vp__group--color';
          g.setAttribute('data-type', 'color');
          var l = label('color', '');
          var mcur = main.querySelector('.on-vp__group--color .on-vp__current');
          if (mcur) {
            var cur = document.createElement('span');
            cur.className = 'on-vp__current';
            cur.setAttribute('data-addon-current', '');
            l.appendChild(cur);
          }
          g.appendChild(l);
          var box = document.createElement('div');
          box.className = swTpl.parentNode.className;
          oldSw.querySelectorAll('[data-fbt-color]').forEach(function (o) {
            var b = strip(swTpl.cloneNode(true));
            b.classList.add('on-vp__swatch--color');
            b.querySelectorAll('.on-swatch').forEach(function (n) { n.remove(); });
            var dot = o.querySelector('.on-swatch');
            if (dot) {
              dot = dot.cloneNode(true);
              if (dotTpl) { dot.style.width = dotTpl.style.width; dot.style.height = dotTpl.style.height; }
              b.insertBefore(dot, b.firstChild);
            }
            var v = o.getAttribute('data-fbt-color');
            b.setAttribute('data-fbt-color', v);
            b.setAttribute('aria-label', v);
            b.setAttribute('title', v);
            if (o.classList.contains('is-active')) b.classList.add('is-active');
            box.appendChild(b);
          });
          g.appendChild(box);
          wrap.appendChild(g);
          oldSw.remove();
          built = true;
        }
        /* Storlek */
        var oldSel = card.querySelector('[data-fbt-size-select]');
        var oldSz = card.querySelector('.on-fbt__sizes');
        var szTpl = main.querySelector('.on-vp__sizes .on-vp__size');
        if ((oldSel || oldSz) && szTpl) {
          var vals = oldSel ? Array.prototype.map.call(oldSel.options, function (o) { return o.value; })
                            : Array.prototype.map.call(oldSz.querySelectorAll('[data-fbt-size]'), function (o) { return o.getAttribute('data-fbt-size'); });
          var g2 = document.createElement('div');
          g2.className = 'on-vp__group on-vp__group--size';
          g2.setAttribute('data-type', 'size');
          var l2 = label('size', oldSel ? oldSel.getAttribute('aria-label') : '');
          /* Storleksguiden: tilläggets egen tabell (on-size-pop-trigger i kortet),
             i samma länkform som huvudväljarens "Storleksguide ›". */
          var trig = card.querySelector('.on-szp-trigger');
          if (trig) {
            l2.classList.add('on-vp__label--help');
            var hs = document.createElement('span');
            hs.className = 'on-vp__sizehelp on-vp__sizehelp--link';
            var hb = document.createElement('button');
            hb.type = 'button';
            hb.className = 'on-vp__sh-link';
            hb.setAttribute('data-addon-sizeguide', '');
            var ht = document.createElement('span');
            ht.textContent = (trig.textContent || '').trim();
            var ha = document.createElement('span');
            ha.className = 'on-vp__sh-arr';
            ha.setAttribute('aria-hidden', 'true');
            ha.textContent = '\u203a';
            hb.appendChild(ht); hb.appendChild(ha);
            hb.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); trig.click(); });
            hs.appendChild(hb);
            l2.appendChild(hs);
          }
          g2.appendChild(l2);
          var mbox = szTpl.parentNode;
          var box2 = document.createElement('div');
          box2.className = mbox.className;
          var per = vals.length > 7 ? Math.ceil(vals.length / 2) : vals.length;
          box2.style.setProperty('--on-vp-per-row', per);
          if (mbox.hasAttribute('data-on-sizefit')) box2.setAttribute('data-on-sizefit', '');
          vals.forEach(function (v) {
            var b = strip(szTpl.cloneNode(true));
            var m = b.querySelector('.on-size-main');
            if (m) m.textContent = v; else b.textContent = v;
            b.setAttribute('data-fbt-size', v);
            b.setAttribute('aria-label', v);
            box2.appendChild(b);
          });
          g2.appendChild(box2);
          wrap.appendChild(g2);
          if (oldSel) oldSel.remove();
          if (oldSz) oldSz.remove();
          card._size = null;
          card._needSize = true;
          card._sizeGroup = g2;
          built = true;
        }
        if (!built) return;
        var add = ctr.querySelector('[data-fbt-add]');
        ctr.insertBefore(wrap, add || null);
        card.classList.add('on-fbt__card--vp');
      }

      /* Tillgänglighet och vald färg i rubriken, som i huvudväljaren. */
      vpMark(card) {
        if (!card.classList.contains('on-fbt__card--vp')) return;
        var ci = parseInt(card.getAttribute('data-color-index'), 10);
        var si = parseInt(card.getAttribute('data-size-index'), 10);
        var hasC = card.getAttribute('data-has-color') === 'true';
        var self = this;
        card.querySelectorAll('.on-vp--addon [data-fbt-size]').forEach(function (b) {
          var val = b.getAttribute('data-fbt-size');
          var ok = card._variants.some(function (v) { return v.available && self.optVal(v, si) === val && (!hasC || !card._color || self.optVal(v, ci) === card._color); });
          b.classList.toggle('is-unavailable', !ok);
        });
        card.querySelectorAll('.on-vp--addon [data-fbt-color]').forEach(function (b) {
          var val = b.getAttribute('data-fbt-color');
          b.classList.toggle('is-unavailable', !card._variants.some(function (v) { return v.available && self.optVal(v, ci) === val; }));
        });
        var cur = card.querySelector('[data-addon-current]');
        var act = card.querySelector('.on-vp--addon [data-fbt-color].is-active');
        if (cur) {
          cur.innerHTML = '';
          if (act) {
            var dot = act.querySelector('.on-swatch');
            if (dot) { dot = dot.cloneNode(true); dot.style.width = '14px'; dot.style.height = '14px'; cur.appendChild(dot); }
            var t = document.createElement('span');
            t.textContent = act.getAttribute('data-fbt-color');
            cur.appendChild(t);
          }
        }
      }
      loadDynamic() {
        var self = this;
        var url = this.getAttribute('data-url');
        var seed = this.getAttribute('data-seed');
        var section = this.getAttribute('data-section') || 'on-fbt-reco-section';
        if (!url || !seed || !this.track) return;
        var full = url + (url.indexOf('?') > -1 ? '&' : '?') + 'product_id=' + seed + '&intent=related&section_id=' + section + '&limit=12';
        fetch(full, { headers: { Accept: 'text/html' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div'); tmp.innerHTML = html;
            var cards = Array.prototype.slice.call(tmp.querySelectorAll('.on-fbt__card'));
            var genders = setOf(self.getAttribute('data-genders'));
            var seasons = setOf(self.getAttribute('data-seasons'));
            var limit = parseInt(self.getAttribute('data-limit') || '8', 10);
            var out = [], seen = {};
            cards.forEach(function (c) {
              var pid = (c.getAttribute('data-pid') || '').trim();
              if (!pid || pid === seed || seen[pid]) return;
              var cg = listOf(c.getAttribute('data-g'));
              var cs = listOf(c.getAttribute('data-s'));
              if (cg.length && genders.size) { if (!(cg.indexOf('unisex') > -1 || cg.some(function (g) { return genders.has(g); }))) return; }
              if (cs.length && seasons.size) { if (!cs.some(function (s) { return seasons.has(s); })) return; }
              seen[pid] = 1; out.push(c);
            });
            out = out.slice(0, limit);
            var harPar = !!self.querySelector('[data-rows-pair] [data-fbt-card]');
            if (!out.length && !harPar) { self.setAttribute('hidden', ''); return; }
            self.track.innerHTML = '';
            out.forEach(function (c) { self.track.appendChild(c); });
            self.querySelectorAll('[data-fbt-card]').forEach(function (c) { self.initCard(c); });
            self.enhanceRows();
            self.applyBadges();
            self.removeAttribute('hidden');
            self.updateArrows();
          })
          .catch(function () {
            if (self.querySelector('[data-rows-pair] [data-fbt-card]')) { self.querySelectorAll('[data-fbt-card]').forEach(function (c) { self.initCard(c); }); self.enhanceRows(); self.removeAttribute('hidden'); }
            else self.setAttribute('hidden', '');
          });
      }
      initCard(card) {
        try { card._variants = JSON.parse(card.querySelector('[data-fbt-variants]').textContent); } catch (e) { card._variants = []; }
        card._color = this.activeVal(card, 'data-fbt-color');
        card._size = this.activeVal(card, 'data-fbt-size');
        this.syncCard(card);
      }
      activeVal(card, attr) {
        var a = card.querySelector('[' + attr + '].is-active') || card.querySelector('[' + attr + ']');
        if (a) return a.getAttribute(attr);
        if (attr === 'data-fbt-size') {
          var sel = card.querySelector('[data-fbt-size-select]');
          if (sel) return sel.value;
        }
        return null;
      }
      onChange(e) {
        var sel = e.target.closest('[data-fbt-size-select]');
        var card = e.target.closest('[data-fbt-card]');
        if (sel && card) { card._size = sel.value; this.syncCard(card); }
      }
      onClick(e) {
        var sw = e.target.closest('[data-fbt-color]');
        var sz = e.target.closest('[data-fbt-size]');
        var add = e.target.closest('[data-fbt-add]');
        var card = e.target.closest('[data-fbt-card]');
        if (sw && card) { this.select(card, '[data-fbt-color]', sw, 'color', sw.getAttribute('data-fbt-color')); }
        else if (sz && card) { this.select(card, '[data-fbt-size]', sz, 'size', sz.getAttribute('data-fbt-size')); }
        else if (add) {
          var ac = add.closest('[data-fbt-card]');
          if (ac && ac._needSize && !ac._size && ac._sizeGroup) {
            var sg = ac._sizeGroup;
            sg.setAttribute('data-nudge', '');
            setTimeout(function () { sg.removeAttribute('data-nudge'); }, 900);
            try { sg.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (er) { sg.scrollIntoView(); }
            return;
          }
          this.addToCart(add);
        }
      }
      select(card, sel, btn, key, val) {
        card.querySelectorAll(sel).forEach((b) => b.classList.toggle('is-active', b === btn));
        card['_' + key] = val;
        this.syncCard(card);
      }
      syncCard(card) {
        var ci = parseInt(card.getAttribute('data-color-index'), 10);
        var si = parseInt(card.getAttribute('data-size-index'), 10);
        var hasC = card.getAttribute('data-has-color') === 'true';
        var hasS = card.getAttribute('data-has-size') === 'true';
        var utanStorlek = !!(card._needSize && !card._size);
        var match = card._variants.find((v) => {
          var ok = true;
          if (hasC) ok = ok && (this.optVal(v, ci) === card._color);
          if (hasS && !utanStorlek) ok = ok && (this.optVal(v, si) === card._size);
          return ok;
        });
        if (!match && card._variants.length) match = card._variants[0];
        if (!match) return;
        this.vpMark(card);
        var addBtn = card.querySelector('[data-fbt-add]');
        if (addBtn && utanStorlek) {
          /* Storleken är inte vald: knappen visar priset men lägger inget förrän
             kunden valt (trycket knuffar till storlekarna, onClick). */
          addBtn.setAttribute('data-variant', '');
          addBtn.disabled = false;
        } else if (addBtn) {
          var gammal = addBtn.getAttribute('data-variant');
          addBtn.setAttribute('data-variant', match.id);
          addBtn.disabled = !match.available;
          /* Byter kunden farg eller storlek pa ett kort som redan ligger i
             paketet ska PAKETET folja med. Annars hade kassan fatt den gamla
             varianten medan kortet visade den nya. */
          if (this.getAttribute('data-bundle') === '1'
              && addBtn.classList.contains('is-chosen')
              && String(gammal) !== String(match.id)) {
            document.dispatchEvent(new CustomEvent('on-vp:addon', { bubbles: true, detail: { id: gammal, remove: true } }));
            document.dispatchEvent(new CustomEvent('on-vp:addon', { bubbles: true, detail: { id: match.id, price: match.price } }));
          }
        }
        /* Rader: knappen säger vad tillägget kostar, som i bilden. */
        if (addBtn && this.classList.contains('on-fbt--rows') && this.getAttribute('data-rows-add')) {
          addBtn.textContent = this.getAttribute('data-rows-add') + ' \u00b7 ' + this.money(match.price);
        }
        var priceEl = card.querySelector('[data-fbt-price]');
        if (priceEl && window.Shopify) {
          if (match.cap && match.cap > match.price) {
            priceEl.innerHTML = '<span class="on-fbt__price-sale">' + this.money(match.price) + '</span> <s class="on-fbt__price-orig">' + this.money(match.cap) + '</s>';
          } else {
            priceEl.textContent = this.money(match.price);
          }
        }
        var img = card.querySelector('.on-fbt__img');
        if (img && match.img) { img.src = match.img; img.srcset = ''; }
      }
      optVal(v, idx) { return idx === 0 ? v.o1 : idx === 1 ? v.o2 : v.o3; }
      /* Butikens format, samma som servern och köpknappen (window.__onMoney i
         on-design-tokens). Omgång 34 använde sidans språk, vilket gav "299 SEK" på
         tyska sidor medan resten skrev "299 kr". */
      money(cents) {
        if (window.__onMoney) return window.__onMoney(cents);
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        try { return (cents / 100).toLocaleString(document.documentElement.lang || undefined, { style: 'currency', currency: cur, maximumFractionDigits: 0 }); }
        catch (e) { return String(Math.round(cents / 100)); }
      }
      addToCart(btn) {
        var id = btn.getAttribute('data-variant');
        if (!id) return;
        /* PAKETLAGE. Tillagget gar till variantvaljarens paket i stallet for
           rakt in i varukorgen: kunden ser totalen pa kopknappen andras och
           lagger allt i korgen i ETT steg. Andra trycket tar bort det igen,
           sa plusset ar en pa/av och inte en envagsdorr. */
        if (this.getAttribute('data-bundle') === '1') {
          var card = btn.closest('[data-fbt-card]');
          var pris = 0;
          if (card && card._variants) {
            var m = card._variants.find(function (v) { return String(v.id) === String(id); });
            if (m) pris = m.price;
          }
          document.dispatchEvent(new CustomEvent('on-vp:addon', {
            bubbles: true, detail: { id: id, price: pris, toggle: true }
          }));
          return;
        }
        btn.disabled = true;
        var body = { items: [{ id: parseInt(id, 10), quantity: 1 }] };
        var cic = document.querySelector('cart-items-component');
        var sid = cic ? (cic.getAttribute('section-id') || cic.getAttribute('data-section-id')) : null;
        if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
        fetch((this.getAttribute('data-cart-add') || '/cart/add'), {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then((r) => r.json())
          .then((added) => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json())
            .then((cart) => {
              document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'on-fbt', data: { source: 'on-fbt', itemCount: cart.item_count, sections: added ? added.sections : null } } }));
              var drawer = document.querySelector('cart-drawer-component');
              if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
              btn.disabled = false;
            }))
          .catch(() => { if (!window.__onOc) window.location.href = '/cart'; btn.disabled = false; });
      }
      scrollBy(dir) {
        if (!this.track) return;
        this.track.scrollBy({ left: dir * (this.track.clientWidth * 0.85), behavior: 'smooth' });
      }
      updateArrows() {
        if (!this.track) return;
        var max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('on-fbt', OnFbt);
  })();
